WiseMetering.Views.Ui.DropZone = Backbone.View.extend({
    tagName: 'div',
    className: 'drop-zone-overlay',

    initialize: function(options) {
        this.$container = options.$container;
        this.message = options.message || i18next.t('common.drop_files_here');
        this.onDrop = options.onDrop;
        this._dragCounter = 0;

        if (!this.$container || this.$container.length === 0) {
            return;
        }

        this.setMessage(this.message);
        this.$container.append(this.$el);

        this._onDragEnter = e => {
            e.preventDefault();
            this._dragCounter++;
            this.$el.addClass('active');
        };

        this._onDragLeave = e => {
            e.preventDefault();
            this._dragCounter--;
            if (this._dragCounter <= 0) {
                this._dragCounter = 0;
                this.$el.removeClass('active');
            }
        };

        this._onDragOver = e => {
            e.preventDefault();
        };

        this._onDropEvent = e => {
            e.preventDefault();
            this._dragCounter = 0;
            this.$el.removeClass('active');
            if (this.onDrop) {
                this.onDrop(e.originalEvent.dataTransfer.files);
            }
        };

        this.$container.on('dragenter', this._onDragEnter);
        this.$container.on('dragleave', this._onDragLeave);
        this.$container.on('dragover', this._onDragOver);
        this.$container.on('drop', this._onDropEvent);
    },

    setMessage: function(message, options = {}) {
        this.message = message;
        const icon = options.icon ? `<i class='${options.icon} drop-zone-icon'></i>` : '';
        const spinner = options.spinner ? "<i class='far fa-spinner fa-spin drop-zone-icon'></i>" : '';
        this.$el.html(`<span>${spinner || icon}${this.message}</span>`);
    },

    transitionMessage: function(message, options = {}) {
        clearTimeout(this._transitionTimeout);
        const $message = this.$('span');

        if ($message.length === 0) {
            this.setMessage(message, options);
            return;
        }

        $message.addClass('changing');
        this._transitionTimeout = setTimeout(() => {
            this.setMessage(message, options);
            this.$('span').addClass('entering');
            requestAnimationFrame(() => this.$('span').removeClass('entering'));
        }, 160);
    },

    show: function(message, options = {}) {
        if (message) {
            this.setMessage(message, options);
        }
        this._dragCounter = 0;
        this.$el.removeClass('success');
        this.$el.addClass('active');
    },

    success: function(message) {
        if (message) {
            this.transitionMessage(message, { icon: 'fas fa-check' });
        }
        this._dragCounter = 0;
        this.$el.addClass('active success');
    },

    hide: function(message) {
        if (message) {
            this.setMessage(message);
        }
        this._dragCounter = 0;
        this.$el.removeClass('active success');
    },

    remove: function() {
        if (this.$container) {
            this.$container.off('dragenter', this._onDragEnter);
            this.$container.off('dragleave', this._onDragLeave);
            this.$container.off('dragover', this._onDragOver);
            this.$container.off('drop', this._onDropEvent);
        }
        clearTimeout(this._transitionTimeout);
        return Backbone.View.prototype.remove.call(this);
    }
});
